import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DeactivateLobbyEntries } from 'src/app/lobby/shared/models/deactivate-lobby-entries';
import { LobbyEntryService } from 'src/app/lobby/shared/services/lobby-entry.service';

@Component({
  selector: 'app-lobby-entries-delete',
  templateUrl: './lobby-entries-delete.component.html',
  styleUrls: ['./lobby-entries-delete.component.scss']
})
export class LobbyEntriesDeleteComponent implements OnInit {
  @Input() public dialogOpened: boolean = false;
  @Output() onDeleted: EventEmitter<any> = new EventEmitter();
  public selectedKeys: number[] = [];
  public lobbyEntriesDeleteForm: FormGroup = new FormGroup({});

  constructor(public lobbyEntryService: LobbyEntryService, public fb: FormBuilder) { }

  ngOnInit() {
    this.createForm();
  }

  public createForm() {
    this.lobbyEntriesDeleteForm = this.fb.group({
      reason: [null, [Validators.required, Validators.pattern(/^[^<>&]*$/)]]
    });
  }

  public open(selectedKeys: number[]) {
    this.dialogOpened = true;
    this.selectedKeys = selectedKeys;
  }

  public delete() {
    const reason = this.lobbyEntriesDeleteForm.value.reason;
    this.lobbyEntryService.deactivateLobbyEntries(new DeactivateLobbyEntries(this.selectedKeys, reason)).subscribe((data) => {
      this.onDeleted.emit();
    }, error => {
      console.error(error);
    });
    this.close();
  }

  public close() {
    this.dialogOpened = false;
    this.selectedKeys = [];
    this.lobbyEntriesDeleteForm.reset();
  }

}
